// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from 'react';
import { classNames } from '@plasmicapp/react-web';

export type PenIconsvgIconProps = React.ComponentProps<'svg'> & {
  title?: string;
};

export function PenIconsvgIcon(props: PenIconsvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      fill={'none'}
      viewBox={'0 0 21 21'}
      height={'1em'}
      width={'1em'}
      style={{
        fill: 'currentcolor',

        ...(style || {}),
      }}
      className={classNames('plasmic-default__svg', className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          'M12.075 4l5.102 5.06L7.16 19a2.28 2.28 0 01-1.007.58L.994 20.973a.753.753 0 01-.928-.921l1.407-5.116c.103-.378.305-.722.584-.999L12.075 4zm7.149-2.03a3.558 3.558 0 010 5.06l-.978.97-5.102-5.06.978-.97a3.628 3.628 0 015.102 0z'
        }
        fill={'currentColor'}
      ></path>
    </svg>
  );
}

export default PenIconsvgIcon;
/* prettier-ignore-end */
